import React, { useState } from "react";
import { useGet } from "seed/api";
import { Loading } from "seed/helpers";
import View from "components/vmisc/templates/Templates.view";

const allCategory = { id: 0, name: "all", ui_settings: { display: { title: "Todas", icon: "fas fa-th" } } };

function Templates({ onSelectFlowTemplate }) {

  const [filters, setFilters] = useState({
    searchTerm: "",
    selectedCategory: 0
  });
  const [selectedFlow, setSelectedFlow] = useState(null);

  const reqFlows = useGet('/flows/get_template_flows', { 
    template_categories: filters.selectedCategory == 0 ? "all" : filters.selectedCategory,
    template_type: "USE_CASE"
  });
  const reqCategories = useGet('/template_categories/get_template_categories', {});

  if (reqCategories.loading || reqFlows.loading) return <Loading />;
  if (reqCategories.error || reqFlows.error) return "Error";

  const categories = reqCategories.data || [];
  const flows = reqFlows.data || [];
  if (!categories.find(c => c.name == "all")) categories.unshift(allCategory);

  const onClickCategory = (categoryId) => {
    const newFilters = {
      ...filters,
      selectedCategory: categoryId
    }
    setFilters(newFilters);
    reqFlows.refetch();
  }

  const onSelectFlow = (flowId) => {
    setSelectedFlow(flowId);
    if (onSelectFlowTemplate) onSelectFlowTemplate(flowId);
  }

  const onClickUnselectFlow = (event) => {
    setSelectedFlow(null);
    if (onSelectFlowTemplate) onSelectFlowTemplate(null);
    event.stopPropagation();
  }

  return (
    <View
      flows={flows}
      categories={categories}
      filters={filters}
      selectedFlow={selectedFlow}
      onSelectFlow={onSelectFlow}
      onClickCategory={onClickCategory}
      onClickUnselectFlow={onClickUnselectFlow}
    />
  );
}


export default Templates;